import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import Button from "helpers/button";
import { getHorizontalAlign } from "helpers/get-section-align";
import { toRGBA } from "helpers/toRGBA";
import HeroLandingPage from "components/hero-landing-page";

const components = {
  normal: ({ children }) => (
    <p className="text-lg sm:text-base text-white font-montserrat font-normal">{children}</p>
  ),
};

const Hero = ({ data }) => {
  const {
    heroPage,
    horizontalAlign: { horizontalAlign },
    title,
    content,
    buttons,
    image,
    overlayColor,
  } = data;

  if (heroPage == "landingPage") return <HeroLandingPage data={data} />;

  return (
    <div className="relative pt-44 pb-44 ">
      <div
        className={`container relative z-[3] flex ${getHorizontalAlign(
          horizontalAlign
        )}`}
      >
        <div className="">
          <div className="text-yellow-400 text-7xl font-bold font-display mb-6 sm:text-h1">
            <RichText value={title.data} />
          </div>
          <div className="paragraph-lg-normal text-gray-300 mb-6 flex justify-center font-montserrat">
            <div className="w-4/5">
              <RichText value={content.data} components={components} />
            </div>
          </div>

          {buttons && (
            <div className="flex items-center gap-4">
              {buttons.map((button, index) => (
                <Button button={button} key={index} />
              ))}
            </div>
          )}
        </div>
      </div>

      {image && (
        <div className="absolute top-0 left-0 w-full h-full">
          <img
            src={image?.src}
            alt={image?.alt}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      {overlayColor?.hex && (
        <div
          className="absolute z-[2] top-0 left-0 w-full h-full"
          style={{
            backgroundColor: toRGBA(overlayColor),
          }}
        />
      )}
    </div>
  );
};

export default Hero;
